import { NEGATIVE_RATING_PERCENT, POSITIVE_RATING_PERCENT, RatingPercent } from 'common/RatingUtilities';
import { ArrayType } from 'common/TypeUtilities';
import { chain, isNumber, partition } from 'lodash';
import { ConsumerOrderReviewFragment } from 'src/gqlReactTypings.generated.d';

/**
 * Given a review, return the rating percent for the review based on the dish ratings.
 * A rating percent is only returned if the majority of rated dishes are rated positively or negatively.
 */
export const getRatingPercentForReview = (review: ConsumerOrderReviewFragment): RatingPercent | null => {
  const reviewDishes: ArrayType<ConsumerOrderReviewFragment['dishes']>[] = review.dishes;
  const ratingPercents = chain(reviewDishes)
    .map((dish) => dish.rating?.ratingPercent)
    .filter(isNumber)
    .value();

  if (ratingPercents.length === 0) {
    return null;
  }

  const [positiveRatingPercents, negativeRatingPercents] = partition(
    ratingPercents,
    (ratingPercent) => ratingPercent === POSITIVE_RATING_PERCENT
  );

  if (positiveRatingPercents.length > negativeRatingPercents.length) {
    return POSITIVE_RATING_PERCENT;
  }

  if (negativeRatingPercents.length > positiveRatingPercents.length) {
    return NEGATIVE_RATING_PERCENT;
  }

  return null;
};
